import React, { useState } from 'react';
import { ListGroupItem } from 'reactstrap';
import styled from 'styled-components';

import DisputePatientMatchModal from '~/components/Patient/Identity/Dispute/SubmitDispute/Modal';

const SListGroupItem = styled(ListGroupItem)`
  color: #fff !important;
  background-color: #b92d2d !important;
`;

const DisputePatientMatchButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleIsModalOpen = () => {
    setIsModalOpen(previous => !previous);
  };

  return (
    <>
      <SListGroupItem
        onClick={toggleIsModalOpen}
        className="side-nav-item d-flex align-items-center border-dark bg-danger text-white"
      >
        Dispute the match of this patient
      </SListGroupItem>

      <DisputePatientMatchModal
        isOpen={isModalOpen}
        toggleIsOpen={toggleIsModalOpen}
      />
    </>
  );
};

export default DisputePatientMatchButton;
